import React, { useContext, useState } from "react";
import { FormattedMessage } from 'react-intl';
import { UserContext } from "../../context/userContext";
import avatar from './../../utils/images/avatar_fluincr.png';

import { getConvertCurrency } from "../../api/exchangeApi";
import { CurrencyContext } from "../../context/currencyContext";
import { useEffect } from "react";

import { ProfileImage } from "./MyCollaborationsStyled";
import { formatDateLocal, formatTimeLocal, fromUTCtoLocal, frontUTCtoLocal, newFormat, newFormatDateLocal, toUTCString } from "../../services/dateServices";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "../../services/generalSevices";

export default function CollaborationItem({ collaboration, handlerSeeCollaboration }) {

    const { currency } = useContext(CurrencyContext);
    const navigate = useNavigate();
    const auxCurrency = currency.symbol;
    const [collaborationPrice, setCollaborationPrice] = useState(null);

    const { userType } = useContext(UserContext);

    useEffect(() => {
        getConvertCurrency({ amount: collaboration.totalprice }).then((response) => {
            //setCollaborationPrice(response[auxCurrency].toFixed(0))
            setCollaborationPrice(response[auxCurrency].toFixed(2))
        })
    }, [currency])

    const renderNotification = ({ collaboration }) => {

        if (userType === 'influencer' && collaboration.readinfluencer === false) {
            return (
                <div className="notification"></div>
            )
        }
        if (userType === 'company' && collaboration.readcompany === false) {
            return (
                <div className="notification"></div>
            )
        }
    }

    return (
        <tr>
            <td className="firstFile"><div className="companyName">
                {(userType === 'influencer') ?
                    (<> <ProfileImage image={(collaboration.imagecompany !== '' && collaboration.imagecompany !== null) ? collaboration.imagecompany : avatar} onClick={() => { navigate(`/${collaboration.usercompany}`) }} />
                        <p className="name" onClick={() => { navigate(`/${collaboration.usercompany}`) }}>{collaboration.namecompany} </p></>) :
                    (<> <ProfileImage image={(collaboration.imageinfluencer !== '' && collaboration.imageinfluencer !== null) ? collaboration.imageinfluencer : avatar} onClick={() => { navigate(`/${collaboration.userinfluencer}`) }} />
                        <p className="name" onClick={() => { navigate(`/${collaboration.userinfluencer}`) }}>{collaboration.name}</p></>)}

            </div></td>

            {/* <td><p className="date">{formatDateLocal(toUTCString(new Date(collaboration.creation)))}</p></td> */}

            {/* <td><p className="date">{formatDateLocal(fromUTCtoLocal(collaboration.creation))}</p></td> */}
            <td><p className="date">{newFormat(collaboration.creation)}</p></td>

            <td> <p className="product" onClick={() => { navigate(`/${collaboration.usercompany}`) }}>{collaboration.nameproduct}</p></td>

            <td><div className="collaborationPrice">
                <p className="price">{/* {currency.symbol} */} ${formatNumber(collaborationPrice)}</p>
                <div className="collaborationButtonContainer">

                    {renderNotification({ collaboration })}

                    <button onClick={() => {
                        handlerSeeCollaboration(collaboration.idcolaboration)
                    }} className="collaborationButton"><FormattedMessage id="my_collaborations_button" defaultMessage="Ver colaboración" />
                    </button>
                </div>
            </div></td>

        </tr>
    )
}